'use strict';

if (!window.productCollectionBar) {
  (function () {
    return;
  });
}

var productCollectionBar = {
  init: function init() {
    /*
    *
    *  並び替えパネル表示
    *
    */
    var initSortPanel = function initSortPanel() {
      $('.js-sortToggle').on('click', toggleSortPanel);
    };
    var toggleSortPanel = function toggleSortPanel(e) {
      var $wrapper = $(e.target).parents('.js-sortWrapper');
      if ($wrapper.hasClass('is-sort-open')) {
        $wrapper.removeClass('is-sort-open');
      } else {
        $wrapper.addClass('is-sort-open');
      }
    };
    // 初期化
    initSortPanel();
  }
};

productCollectionBar.init();